import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {OptInAccordionTitleBox} from "./boxes/opt-in-accordion-title.box";

export const OptInAccordionTitleComponent: React.FC = observer((props) => {
    const services = useServices();
    return (
        <OptInAccordionTitleBox>
            {services.translation.translate('JACKPOT_BET_RULES')}
        </OptInAccordionTitleBox>
    )
})